<button #menuButton
	class="menu-btn btn-none"
	(keyup.enter)="$event.stopPropagation();"
	(click)="openMenu($event)">
	<i class="ficon-app-dots-vertical"></i>
</button>
<menu>
	<ng-content></ng-content>
</menu>
